export default {
	left: {
		heading: `How it Works`,
		body: `Now that you have watched our videos, you can play this Ask, Listen, Learn Jeopardy!-style game any time you want and prove that you know ALL about the BRAIN! This is perfect for safe screen time, a science or health lesson, or a group activity in the classroom! Kids will learn about saying YES to a healthy lifestyle and NO to underage drinking by finding out how alcohol affects their developing brains.`,
	},
	one: {
		heading: `Pick`,
		body: `Select a category and "dollar" amount from the board.`,
	},
	two: {
		heading: `Answer`,
		body: `You will receive a Jeopardy!-style answer with multiple choice questions from which to choose to prove you know ALL about the BRAIN.`,
	},
	three: {
		heading: `Score`,
		body: `If you get it right &mdash; WELL DONE! &mdash; the "dollar" value will be added to your total. But look out! If you get the question wrong, that amount will be subtracted.`,
	},
};
